import React, { useMemo } from "react";
import styled from "styled-components";
import { Row, theme } from "uikit";

import Parking from "../../../../../../../services/Parking2";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";

const StyledCell = styled(Row)<{ active: boolean; background?: string }>`
	padding: 9px 6px;
	color: ${(props) => (props.active ? props.color : "lightgray")} !important;
	background: ${(props) => props?.background || "transparent"};
	width: 100%;
	display: flex;
	gap: 5px;
	font-size: 12px;
	white-space: wrap;
	align-items: center;
	z-index: 1000;

	${theme.longWord}
`;

const NameCellContent: React.FC<NameCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(() => item.name?.[lang] ?? "", [item.name, lang]);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<StyledCell
				active={item.active}
				justify="flex-start"
				style={{ fontSize: 14 }}
			>
				{content}
			</StyledCell>
		</CellContentRoot>
	);
};

declare namespace NameCellContent {
	interface Props {
		item: Parking.Model;
	}
}

export default NameCellContent;
